import './style/index.less';
import MobileAreaCodeSelector from './MobileAreaCodeSelector';

export default MobileAreaCodeSelector;
